import React from "react";
import PropTypes from "prop-types";
import RenameControl from "../../components/ui/RenameControl";

/**
 * EditorTitle: props => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Displays a title for the document editor/viewer
 * module
 *
 * @param {*} props
 */
const EditorTitle = props => (
  <div className="ed-editor-title">
    <RenameControl
      isReadOnlyMode={props.isReadOnlyMode}
      saveDocumentTitle={props.saveDocumentTitle}
      filename={props.file.filename}
    />
  </div>
);

EditorTitle.propTypes = {
  /**
   * Current file open in editor
   */
  file: PropTypes.shape({
    filename: PropTypes.string
  }),
  /**
   * True if the editor does not permit any changes to the document
   */
  isReadOnlyMode: PropTypes.bool,
  /**
   * Fired when the user attempts to save his new document title
   */
  saveDocumentTitle: PropTypes.func.isRequired
};

EditorTitle.defaultProps = {
  file: {
    filename: null
  },

  isReadOnlyMode: false
};

export default EditorTitle;



// WEBPACK FOOTER //
// ./src/modules/editor/EditorTitle.js